import React from 'react';
import { ProgressBar } from 'primereact/progressbar';

const Loader = ({ active, children }) => {
  return active ? (
    <ProgressBar mode="indeterminate" style={{ height: '6px' }} />
  ) : (
    children
  );
};

export default React.memo(Loader);
